import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import { PrevisioniService } from './previsioni.service';
import { FormatUtils } from 'app/generic/format-utils';

@Component({
    selector: 'previsioni',
    templateUrl: './previsioni.component.html',
    styleUrls: ['./previsioni.component.scss'],
    providers: [PrevisioniService]
})
export class PrevisioniComponent implements OnInit {

    modelList: any;
    previsioniPerGiornoList: any[] = [];
    noteProtCiv: any;
    avvertenze: any;
    promiseBusy: Promise<any>;
    giorniDesc: any = ["OGGI", "DOMANI", "DOPODOMANI"];

    arrayForMapImgOggiMattina: any[] = [];
    arrayForMapImgOggiPome: any[] = [];
    arrayForMapImgOggiSera: any[] = [];

    arrayForMapImgDomaniMattina: any[] = [];
    arrayForMapImgDomaniPome: any[] = [];
    arrayForMapImgDomaniSera: any[] = [];

    arrayForMapImgDopodomaniMattina: any[] = [];
    arrayForMapImgDopodomaniPome: any[] = [];
    arrayForMapImgDopodomaniSera: any[] = [];

    lastPosX: number = 0;
    lastPosY: number = 0;

    ctx;
    lastImage;

    indZone=[
        {
            zona:1,
            ind:"Piana Campana, Napoli, Isole, Area Vesuviana"
        },
        {
            zona:2,
            ind:"Alto Volturno, Matese"
        },
        {
            zona:3,
            ind:"Penisola Sorrentina-Amalfitana, Monti di Sarno e Picentini"
        },
        {
            zona:4,
            ind:"Alta Irpinia, Sannio"
        },
        {
            zona:5,
            ind:"Tusciano e Alto Sele"
        },
        {
            zona:6,
            ind:"Piana Sele e Alto Cilento"
        },
        {
            zona:7,
            ind:"Tanagro"
        },
        {
            zona:8,
            ind:"Basso Cilento"
        },
        
    ]

    // activeTabIndex = 0;
    // tabs=[{label:"Oggi"},{label:"Domani"},{label:"Dopodomani"}]

    @ViewChild('canvasElem') canvasElem: ElementRef;
    @ViewChild('canvasElemPome') canvasElemPome: ElementRef;
    @ViewChild('canvasElemSera') canvasElemSera: ElementRef;

    @ViewChild('canvasElemDomani') canvasElemDomani: ElementRef;
    @ViewChild('canvasElemDomaniPome') canvasElemDomaniPome: ElementRef;
    @ViewChild('canvasElemDomaniSera') canvasElemDomaniSera: ElementRef;

    @ViewChild('canvasElemDopodomani') canvasElemDopodomani: ElementRef;
    @ViewChild('canvasElemDopodomaniPome') canvasElemDopodomaniPome: ElementRef;
    @ViewChild('canvasElemDopodomaniSera') canvasElemDopodomaniSera: ElementRef;

    today: number; // = new Date().getDay()
    tomorrow: number; // = (today+1)%7;
    dayaftertomorrow: number;// number; = (today+2)%7;

    giornoArray =
        ["Domenica",
            "Lunedì",
            "Martedì",
            "Mercoledì",
            "Giovedì",
            "Venerdì",
            "Sabato"
        ];

    constructor(public restService: PrevisioniService, private _sanitizer: DomSanitizer) {

    }

    ngOnInit() {
        // document.getElementById('nb-global-spinner').style.display = 'block';
    }
    
    ngAfterViewInit() {
        this.setupAllCanvas();
        this.caricaUltimoBollettinoMeteo();
    }



    setupAllCanvas() {

        this.setupInitCanvas(this.canvasElem);
        this.setupInitCanvas(this.canvasElemPome);
        this.setupInitCanvas(this.canvasElemSera);

        this.setupInitCanvas(this.canvasElemDomani);
        this.setupInitCanvas(this.canvasElemDomaniPome);
        this.setupInitCanvas(this.canvasElemDomaniSera);

        this.setupInitCanvas(this.canvasElemDopodomani);
        this.setupInitCanvas(this.canvasElemDopodomaniPome);
        this.setupInitCanvas(this.canvasElemDopodomaniSera);

    }

    setupInitCanvas(canvas) {
        if (!canvas || !canvas.nativeElement) {
            console.error('Canvas non valido:', canvas);
            return;
        }

        const ref = this;
        this.ctx = canvas.nativeElement.getContext('2d');

        canvas.nativeElement.height = 316;
        canvas.nativeElement.width = 282;

        const img = new Image();
        img.onload = function () {
            ref.ctx = canvas.nativeElement.getContext('2d');

            ref.ctx.clearRect(0, 0, canvas.nativeElement.width, canvas.nativeElement.height);

            // Disegna immagine sul canvas
            ref.ctx.drawImage(img, 0, 0, 282, 316);

            // Salva l'immagine come ultima immagine
            ref.lastImage = new Image();
            ref.lastImage.src = canvas.nativeElement.toDataURL();
        };
        img.src = 'assets/images/mappa-vuota-campania.png';
    }


    populateCanvas() {

        this.createArrayForMapImgOggiMattina();
        this.createArrayForMapImgOggiPome();
        this.createArrayForMapImgOggiSera();
        this.createArrayForMapImgDomaniMattina();
        this.createArrayForMapImgDomaniPome();
        this.createArrayForMapImgDomaniSera();
        this.createArrayForMapImgDopodomaniMattina();
        this.createArrayForMapImgDopodomaniPome();
        this.createArrayForMapImgDopodomaniSera();

    }

    addImageToCanvas(urlImg: string, posX: number, posY: number, canvas) {

        var ref = this;

        (function () {
            var lastImage = new Image();
            lastImage.src = canvas.nativeElement.toDataURL();

            var img = new Image();
            img.onload = function () {

                (function (lastImage, img) {

                    ref.ctx = canvas.nativeElement.getContext('2d');

                    //aggiungo nuova immagine nella posizione (x,y)
                    ref.ctx.drawImage(img, posX, posY, 35, 30);

                })(lastImage, img);
            };

            img.src = 'assets/images/' + urlImg;
        }.bind(this))();

    }

    

    caricaUltimoBollettinoMeteo() {
        let ref = this;

        // this.promiseBusy = this.restService.selectAll();
        // console.log(this.promiseBusy);

        ref.restService.selectAll().then(
            res => {
                if (res != null) {       
                    this.modelList = res;
                    this.previsioniPerGiornoList = res.previsioniPerGiornoList;
                    
                    this.noteProtCiv = this._sanitizer.bypassSecurityTrustHtml(res.noteProtCiv);
                    this.avvertenze = this._sanitizer.bypassSecurityTrustHtml(res.avvertenze);
                    this.populateCanvas();

                    //this.today = new Date().getDay();
                    this.today = FormatUtils.dateITAFromDateString(this.previsioniPerGiornoList[0].dataRiferimento).getDay();                   
                    this.tomorrow = (this.today + 1) % 7;
                    this.dayaftertomorrow = (this.today + 2) % 7;

                    let elementsDOM = document.querySelectorAll("nb-tabset > ul > li > a");
                    elementsDOM[0].innerHTML = this.giornoArray[this.today] + " " + this.previsioniPerGiornoList[0].dataRiferimento;
                    elementsDOM[1].innerHTML = this.giornoArray[this.tomorrow] + " " + this.previsioniPerGiornoList[1].dataRiferimento;
                    elementsDOM[2].innerHTML = this.giornoArray[this.dayaftertomorrow] + " " + this.previsioniPerGiornoList[2].dataRiferimento;

                    let elementsHeadDOM = document.querySelectorAll("nb-tabset > ul > li");
                    let elementsBodyDOM = document.querySelectorAll("nb-tabset > ngb-tab");
                    var oggiDay = new Date();
                    var oggi = FormatUtils.dateITAFromDateString(oggiDay.getDate() + "/" + (oggiDay.getMonth() + 1) + "/" + oggiDay.getFullYear());

                    if ((oggi > FormatUtils.dateITAFromDateString(this.previsioniPerGiornoList[0].dataRiferimento))
                        && (oggi <= FormatUtils.dateITAFromDateString(this.previsioniPerGiornoList[1].dataRiferimento))
                    ) {

                        let element: HTMLElement = elementsHeadDOM[1] as HTMLElement;
                        element.click();
                        elementsHeadDOM[0].remove();
                        elementsBodyDOM[0].remove();

                    } else if ((oggi > FormatUtils.dateITAFromDateString(this.previsioniPerGiornoList[1].dataRiferimento))
                        && (oggi <= FormatUtils.dateITAFromDateString(this.previsioniPerGiornoList[2].dataRiferimento))
                    ) {

                        let element: HTMLElement = elementsHeadDOM[2] as HTMLElement;
                        element.click();
                        elementsHeadDOM[0].remove();
                        elementsHeadDOM[1].remove();
                        elementsBodyDOM[0].remove();
                        elementsBodyDOM[1].remove();

                    }
                    // document.getElementById('nb-global-spinner').style.display = 'none';
                    // document.getElementsByClassName('scrollable-container')[0].scrollTop = 0;
                }

            }
        )
    }




    createArrayForMapImgOggiMattina() {

        var ref = this;

        this.arrayForMapImgOggiMattina = [

            {

                cielo: ref.previsioniPerGiornoList[0].meteoMappa[0].mattinaCielo,
                vento: ref.previsioniPerGiornoList[0].meteoMappa[0].mattinaVento,
                cieloPos: {
                    posX: 18,
                    posY: 97
                },
                ventoPos: {
                    posX: 53,
                    posY: 138
                }

            },
            {

                cielo: ref.previsioniPerGiornoList[0].meteoMappa[1].mattinaCielo,
                vento: ref.previsioniPerGiornoList[0].meteoMappa[1].mattinaVento,
                cieloPos: {
                    posX: 40,
                    posY: 43
                },
                ventoPos: {
                    posX: 77,
                    posY: 87
                }

            },
            {

                cielo: ref.previsioniPerGiornoList[0].meteoMappa[2].mattinaCielo,
                vento: ref.previsioniPerGiornoList[0].meteoMappa[2].mattinaVento,
                cieloPos: {
                    posX: 105,
                    posY: 135
                },
                ventoPos: {
                    posX: 113,
                    posY: 175
                }

            },
            {

                cielo: ref.previsioniPerGiornoList[0].meteoMappa[3].mattinaCielo,
                vento: ref.previsioniPerGiornoList[0].meteoMappa[3].mattinaVento,
                cieloPos: {
                    posX: 134,
                    posY: 75
                },
                ventoPos: {
                    posX: 173,
                    posY: 120
                }

            },
            {

                cielo: ref.previsioniPerGiornoList[0].meteoMappa[4].mattinaCielo,
                vento: ref.previsioniPerGiornoList[0].meteoMappa[4].mattinaVento,
                cieloPos: {
                    posX: 160,
                    posY: 180
                },
                ventoPos: {
                    posX: 188,
                    posY: 163
                }

            },
            {

                cielo: ref.previsioniPerGiornoList[0].meteoMappa[5].mattinaCielo,
                vento: ref.previsioniPerGiornoList[0].meteoMappa[5].mattinaVento,
                cieloPos: {
                    posX: 164,
                    posY: 219
                },
                ventoPos: {
                    posX: 193,
                    posY: 244
                }

            },
            {

                cielo: ref.previsioniPerGiornoList[0].meteoMappa[6].mattinaCielo,
                vento: ref.previsioniPerGiornoList[0].meteoMappa[6].mattinaVento,
                cieloPos: {
                    posX: 227,
                    posY: 183
                },
                ventoPos: {
                    posX: 233,
                    posY: 226
                }

            },
            {

                cielo: ref.previsioniPerGiornoList[0].meteoMappa[7].mattinaCielo,
                vento: ref.previsioniPerGiornoList[0].meteoMappa[7].mattinaVento,
                cieloPos: {
                    posX: 201,
                    posY: 283
                },
                ventoPos: {
                    posX: 233,
                    posY: 270
                }

            }

        ];

        ref.setupInitCanvas(ref.canvasElem);

        for (var i = 0; i < this.arrayForMapImgOggiMattina.length; i++) {

            (function (i) {
                ref.addImageToCanvas(ref.arrayForMapImgOggiMattina[i].cielo, ref.arrayForMapImgOggiMattina[i].cieloPos.posX, ref.arrayForMapImgOggiMattina[i].cieloPos.posY, ref.canvasElem);
                ref.addImageToCanvas(ref.arrayForMapImgOggiMattina[i].vento, ref.arrayForMapImgOggiMattina[i].ventoPos.posX, ref.arrayForMapImgOggiMattina[i].ventoPos.posY, ref.canvasElem);
            })(i)

        }

        ref.addImageToCanvas(ref.previsioniPerGiornoList[0].meteoMappa[8].mattinaMare, 45, 180, ref.canvasElem);
        ref.addImageToCanvas(ref.previsioniPerGiornoList[0].meteoMappa[9].mattinaMare, 110, 225, ref.canvasElem);

    }

    createArrayForMapImgOggiPome() {

        var ref = this;

        this.arrayForMapImgOggiPome = [

            {

                cielo: ref.previsioniPerGiornoList[0].meteoMappa[0].pomeriggioCielo,
                vento: ref.previsioniPerGiornoList[0].meteoMappa[0].pomeriggioVento,
                cieloPos: {
                    posX: 18,
                    posY: 97
                },
                ventoPos: {
                    posX: 53,
                    posY: 138
                }

            },
            {

                cielo: ref.previsioniPerGiornoList[0].meteoMappa[1].pomeriggioCielo,
                vento: ref.previsioniPerGiornoList[0].meteoMappa[1].pomeriggioVento,
                cieloPos: {
                    posX: 40,
                    posY: 43
                },
                ventoPos: {
                    posX: 77,
                    posY: 87
                }

            },
            {

                cielo: ref.previsioniPerGiornoList[0].meteoMappa[2].pomeriggioCielo,
                vento: ref.previsioniPerGiornoList[0].meteoMappa[2].pomeriggioVento,
                cieloPos: {
                    posX: 105,
                    posY: 135
                },
                ventoPos: {
                    posX: 113,
                    posY: 175
                }

            },
            {

                cielo: ref.previsioniPerGiornoList[0].meteoMappa[3].pomeriggioCielo,
                vento: ref.previsioniPerGiornoList[0].meteoMappa[3].pomeriggioVento,
                cieloPos: {
                    posX: 134,
                    posY: 75
                },
                ventoPos: {
                    posX: 173,
                    posY: 120
                }

            },
            {

                cielo: ref.previsioniPerGiornoList[0].meteoMappa[4].pomeriggioCielo,
                vento: ref.previsioniPerGiornoList[0].meteoMappa[4].pomeriggioVento,
                cieloPos: {
                    posX: 160,
                    posY: 180
                },
                ventoPos: {
                    posX: 188,
                    posY: 163
                }

            },
            {

                cielo: ref.previsioniPerGiornoList[0].meteoMappa[5].pomeriggioCielo,
                vento: ref.previsioniPerGiornoList[0].meteoMappa[5].pomeriggioVento,
                cieloPos: {
                    posX: 164,
                    posY: 219
                },
                ventoPos: {
                    posX: 193,
                    posY: 244
                }

            },
            {

                cielo: ref.previsioniPerGiornoList[0].meteoMappa[6].pomeriggioCielo,
                vento: ref.previsioniPerGiornoList[0].meteoMappa[6].pomeriggioVento,
                cieloPos: {
                    posX: 227,
                    posY: 183
                },
                ventoPos: {
                    posX: 233,
                    posY: 226
                }

            },
            {

                cielo: ref.previsioniPerGiornoList[0].meteoMappa[7].pomeriggioCielo,
                vento: ref.previsioniPerGiornoList[0].meteoMappa[7].pomeriggioVento,
                cieloPos: {
                    posX: 201,
                    posY: 283
                },
                ventoPos: {
                    posX: 233,
                    posY: 270
                }

            }

        ];

        ref.setupInitCanvas(ref.canvasElemPome);

        for (var i = 0; i < this.arrayForMapImgOggiPome.length; i++) {

            (function (i) {
                ref.addImageToCanvas(ref.arrayForMapImgOggiPome[i].cielo, ref.arrayForMapImgOggiPome[i].cieloPos.posX, ref.arrayForMapImgOggiPome[i].cieloPos.posY, ref.canvasElemPome);
                ref.addImageToCanvas(ref.arrayForMapImgOggiPome[i].vento, ref.arrayForMapImgOggiPome[i].ventoPos.posX, ref.arrayForMapImgOggiPome[i].ventoPos.posY, ref.canvasElemPome);
            })(i)

        }

        ref.addImageToCanvas(ref.previsioniPerGiornoList[0].meteoMappa[8].pomeriggioMare, 45, 180, ref.canvasElemPome);
        ref.addImageToCanvas(ref.previsioniPerGiornoList[0].meteoMappa[9].pomeriggioMare, 110, 225, ref.canvasElemPome);

    }

    createArrayForMapImgOggiSera() {

        var ref = this;

        this.arrayForMapImgOggiSera = [

            {

                cielo: ref.previsioniPerGiornoList[0].meteoMappa[0].seraCielo,
                vento: ref.previsioniPerGiornoList[0].meteoMappa[0].seraVento,
                cieloPos: {
                    posX: 18,
                    posY: 97
                },
                ventoPos: {
                    posX: 53,
                    posY: 138
                }

            },
            {

                cielo: ref.previsioniPerGiornoList[0].meteoMappa[1].seraCielo,
                vento: ref.previsioniPerGiornoList[0].meteoMappa[1].seraVento,
                cieloPos: {
                    posX: 40,
                    posY: 43
                },
                ventoPos: {
                    posX: 77,
                    posY: 87
                }

            },
            {

                cielo: ref.previsioniPerGiornoList[0].meteoMappa[2].seraCielo,
                vento: ref.previsioniPerGiornoList[0].meteoMappa[2].seraVento,
                cieloPos: {
                    posX: 105,
                    posY: 135
                },
                ventoPos: {
                    posX: 113,
                    posY: 175
                }

            },
            {

                cielo: ref.previsioniPerGiornoList[0].meteoMappa[3].seraCielo,
                vento: ref.previsioniPerGiornoList[0].meteoMappa[3].seraVento,
                cieloPos: {
                    posX: 134,
                    posY: 75
                },
                ventoPos: {
                    posX: 173,
                    posY: 120
                }

            },
            {

                cielo: ref.previsioniPerGiornoList[0].meteoMappa[4].seraCielo,
                vento: ref.previsioniPerGiornoList[0].meteoMappa[4].seraVento,
                cieloPos: {
                    posX: 160,
                    posY: 180
                },
                ventoPos: {
                    posX: 188,
                    posY: 163
                }

            },
            {

                cielo: ref.previsioniPerGiornoList[0].meteoMappa[5].seraCielo,
                vento: ref.previsioniPerGiornoList[0].meteoMappa[5].seraVento,
                cieloPos: {
                    posX: 164,
                    posY: 219
                },
                ventoPos: {
                    posX: 193,
                    posY: 244
                }

            },
            {

                cielo: ref.previsioniPerGiornoList[0].meteoMappa[6].seraCielo,
                vento: ref.previsioniPerGiornoList[0].meteoMappa[6].seraVento,
                cieloPos: {
                    posX: 227,
                    posY: 183
                },
                ventoPos: {
                    posX: 233,
                    posY: 226
                }

            },
            {

                cielo: ref.previsioniPerGiornoList[0].meteoMappa[7].seraCielo,
                vento: ref.previsioniPerGiornoList[0].meteoMappa[7].seraVento,
                cieloPos: {
                    posX: 201,
                    posY: 283
                },
                ventoPos: {
                    posX: 233,
                    posY: 270
                }

            }

        ];

        ref.setupInitCanvas(ref.canvasElemSera);

        for (var i = 0; i < this.arrayForMapImgOggiSera.length; i++) {

            (function (i) {
                ref.addImageToCanvas(ref.arrayForMapImgOggiSera[i].cielo, ref.arrayForMapImgOggiSera[i].cieloPos.posX, ref.arrayForMapImgOggiSera[i].cieloPos.posY, ref.canvasElemSera);
                ref.addImageToCanvas(ref.arrayForMapImgOggiSera[i].vento, ref.arrayForMapImgOggiSera[i].ventoPos.posX, ref.arrayForMapImgOggiSera[i].ventoPos.posY, ref.canvasElemSera);
            })(i)

        }

        ref.addImageToCanvas(ref.previsioniPerGiornoList[0].meteoMappa[8].seraMare, 45, 180, ref.canvasElemSera);
        ref.addImageToCanvas(ref.previsioniPerGiornoList[0].meteoMappa[9].seraMare, 110, 225, ref.canvasElemSera);

    }

    createArrayForMapImgDomaniMattina() {

        var ref = this;

        this.arrayForMapImgDomaniMattina = [

            {

                cielo: ref.previsioniPerGiornoList[1].meteoMappa[0].mattinaCielo,
                vento: ref.previsioniPerGiornoList[1].meteoMappa[0].mattinaVento,
                cieloPos: {
                    posX: 18,
                    posY: 97
                },
                ventoPos: {
                    posX: 53,
                    posY: 138
                }

            },
            {

                cielo: ref.previsioniPerGiornoList[1].meteoMappa[1].mattinaCielo,
                vento: ref.previsioniPerGiornoList[1].meteoMappa[1].mattinaVento,
                cieloPos: {
                    posX: 40,
                    posY: 43
                },
                ventoPos: {
                    posX: 77,
                    posY: 87
                }

            },
            {

                cielo: ref.previsioniPerGiornoList[1].meteoMappa[2].mattinaCielo,
                vento: ref.previsioniPerGiornoList[1].meteoMappa[2].mattinaVento,
                cieloPos: {
                    posX: 105,
                    posY: 135
                },
                ventoPos: {
                    posX: 113,
                    posY: 175
                }

            },
            {

                cielo: ref.previsioniPerGiornoList[1].meteoMappa[3].mattinaCielo,
                vento: ref.previsioniPerGiornoList[1].meteoMappa[3].mattinaVento,
                cieloPos: {
                    posX: 134,
                    posY: 75
                },
                ventoPos: {
                    posX: 173,
                    posY: 120
                }

            },
            {

                cielo: ref.previsioniPerGiornoList[1].meteoMappa[4].mattinaCielo,
                vento: ref.previsioniPerGiornoList[1].meteoMappa[4].mattinaVento,
                cieloPos: {
                    posX: 160,
                    posY: 180
                },
                ventoPos: {
                    posX: 188,
                    posY: 163
                }

            },
            {

                cielo: ref.previsioniPerGiornoList[1].meteoMappa[5].mattinaCielo,
                vento: ref.previsioniPerGiornoList[1].meteoMappa[5].mattinaVento,
                cieloPos: {
                    posX: 164,
                    posY: 219
                },
                ventoPos: {
                    posX: 193,
                    posY: 244
                }

            },
            {

                cielo: ref.previsioniPerGiornoList[1].meteoMappa[6].mattinaCielo,
                vento: ref.previsioniPerGiornoList[1].meteoMappa[6].mattinaVento,
                cieloPos: {
                    posX: 227,
                    posY: 183
                },
                ventoPos: {
                    posX: 233,
                    posY: 226
                }

            },
            {

                cielo: ref.previsioniPerGiornoList[1].meteoMappa[7].mattinaCielo,
                vento: ref.previsioniPerGiornoList[1].meteoMappa[7].mattinaVento,
                cieloPos: {
                    posX: 201,
                    posY: 283
                },
                ventoPos: {
                    posX: 233,
                    posY: 270
                }

            }

        ];

        ref.setupInitCanvas(ref.canvasElemDomani);

        for (var i = 0; i < this.arrayForMapImgDomaniMattina.length; i++) {

            (function (i) {
                ref.addImageToCanvas(ref.arrayForMapImgDomaniMattina[i].cielo, ref.arrayForMapImgDomaniMattina[i].cieloPos.posX, ref.arrayForMapImgDomaniMattina[i].cieloPos.posY, ref.canvasElemDomani);
                ref.addImageToCanvas(ref.arrayForMapImgDomaniMattina[i].vento, ref.arrayForMapImgDomaniMattina[i].ventoPos.posX, ref.arrayForMapImgDomaniMattina[i].ventoPos.posY, ref.canvasElemDomani);
            })(i)

        }

        ref.addImageToCanvas(ref.previsioniPerGiornoList[1].meteoMappa[8].mattinaMare, 45, 180, ref.canvasElemDomani);
        ref.addImageToCanvas(ref.previsioniPerGiornoList[1].meteoMappa[9].mattinaMare, 110, 225, ref.canvasElemDomani);

    }

    createArrayForMapImgDomaniPome() {

        var ref = this;

        this.arrayForMapImgDomaniPome = [

            {

                cielo: ref.previsioniPerGiornoList[1].meteoMappa[0].pomeriggioCielo,
                vento: ref.previsioniPerGiornoList[1].meteoMappa[0].pomeriggioVento,
                cieloPos: {
                    posX: 18,
                    posY: 97
                },
                ventoPos: {
                    posX: 53,
                    posY: 138
                }

            },
            {

                cielo: ref.previsioniPerGiornoList[1].meteoMappa[1].pomeriggioCielo,
                vento: ref.previsioniPerGiornoList[1].meteoMappa[1].pomeriggioVento,
                cieloPos: {
                    posX: 40,
                    posY: 43
                },
                ventoPos: {
                    posX: 77,
                    posY: 87
                }

            },
            {

                cielo: ref.previsioniPerGiornoList[1].meteoMappa[2].pomeriggioCielo,
                vento: ref.previsioniPerGiornoList[1].meteoMappa[2].pomeriggioVento,
                cieloPos: {
                    posX: 105,
                    posY: 135
                },
                ventoPos: {
                    posX: 113,
                    posY: 175
                }

            },
            {

                cielo: ref.previsioniPerGiornoList[1].meteoMappa[3].pomeriggioCielo,
                vento: ref.previsioniPerGiornoList[1].meteoMappa[3].pomeriggioVento,
                cieloPos: {
                    posX: 134,
                    posY: 75
                },
                ventoPos: {
                    posX: 173,
                    posY: 120
                }

            },
            {

                cielo: ref.previsioniPerGiornoList[1].meteoMappa[4].pomeriggioCielo,
                vento: ref.previsioniPerGiornoList[1].meteoMappa[4].pomeriggioVento,
                cieloPos: {
                    posX: 160,
                    posY: 180
                },
                ventoPos: {
                    posX: 188,
                    posY: 163
                }

            },
            {

                cielo: ref.previsioniPerGiornoList[1].meteoMappa[5].pomeriggioCielo,
                vento: ref.previsioniPerGiornoList[1].meteoMappa[5].pomeriggioVento,
                cieloPos: {
                    posX: 164,
                    posY: 219
                },
                ventoPos: {
                    posX: 193,
                    posY: 244
                }

            },
            {

                cielo: ref.previsioniPerGiornoList[1].meteoMappa[6].pomeriggioCielo,
                vento: ref.previsioniPerGiornoList[1].meteoMappa[6].pomeriggioVento,
                cieloPos: {
                    posX: 227,
                    posY: 183
                },
                ventoPos: {
                    posX: 233,
                    posY: 226
                }

            },
            {

                cielo: ref.previsioniPerGiornoList[1].meteoMappa[7].pomeriggioCielo,
                vento: ref.previsioniPerGiornoList[1].meteoMappa[7].pomeriggioVento,
                cieloPos: {
                    posX: 201,
                    posY: 283
                },
                ventoPos: {
                    posX: 233,
                    posY: 270
                }

            }

        ];

        ref.setupInitCanvas(ref.canvasElemDomaniPome);

        for (var i = 0; i < this.arrayForMapImgDomaniPome.length; i++) {

            (function (i) {
                ref.addImageToCanvas(ref.arrayForMapImgDomaniPome[i].cielo, ref.arrayForMapImgDomaniPome[i].cieloPos.posX, ref.arrayForMapImgDomaniPome[i].cieloPos.posY, ref.canvasElemDomaniPome);
                ref.addImageToCanvas(ref.arrayForMapImgDomaniPome[i].vento, ref.arrayForMapImgDomaniPome[i].ventoPos.posX, ref.arrayForMapImgDomaniPome[i].ventoPos.posY, ref.canvasElemDomaniPome);
            })(i)

        }

        ref.addImageToCanvas(ref.previsioniPerGiornoList[1].meteoMappa[8].pomeriggioMare, 45, 180, ref.canvasElemDomaniPome);
        ref.addImageToCanvas(ref.previsioniPerGiornoList[1].meteoMappa[9].pomeriggioMare, 110, 225, ref.canvasElemDomaniPome);

    }

    createArrayForMapImgDomaniSera() {

        var ref = this;

        this.arrayForMapImgDomaniSera = [

            {

                cielo: ref.previsioniPerGiornoList[1].meteoMappa[0].seraCielo,
                vento: ref.previsioniPerGiornoList[1].meteoMappa[0].seraVento,
                cieloPos: {
                    posX: 18,
                    posY: 97
                },
                ventoPos: {
                    posX: 53,
                    posY: 138
                }

            },
            {

                cielo: ref.previsioniPerGiornoList[1].meteoMappa[1].seraCielo,
                vento: ref.previsioniPerGiornoList[1].meteoMappa[1].seraVento,
                cieloPos: {
                    posX: 40,
                    posY: 43
                },
                ventoPos: {
                    posX: 77,
                    posY: 87
                }

            },
            {

                cielo: ref.previsioniPerGiornoList[1].meteoMappa[2].seraCielo,
                vento: ref.previsioniPerGiornoList[1].meteoMappa[2].seraVento,
                cieloPos: {
                    posX: 105,
                    posY: 135
                },
                ventoPos: {
                    posX: 113,
                    posY: 175
                }

            },
            {

                cielo: ref.previsioniPerGiornoList[1].meteoMappa[3].seraCielo,
                vento: ref.previsioniPerGiornoList[1].meteoMappa[3].seraVento,
                cieloPos: {
                    posX: 134,
                    posY: 75
                },
                ventoPos: {
                    posX: 173,
                    posY: 120
                }

            },
            {

                cielo: ref.previsioniPerGiornoList[1].meteoMappa[4].seraCielo,
                vento: ref.previsioniPerGiornoList[1].meteoMappa[4].seraVento,
                cieloPos: {
                    posX: 160,
                    posY: 180
                },
                ventoPos: {
                    posX: 188,
                    posY: 163
                }

            },
            {

                cielo: ref.previsioniPerGiornoList[1].meteoMappa[5].seraCielo,
                vento: ref.previsioniPerGiornoList[1].meteoMappa[5].seraVento,
                cieloPos: {
                    posX: 164,
                    posY: 219
                },
                ventoPos: {
                    posX: 193,
                    posY: 244
                }

            },
            {

                cielo: ref.previsioniPerGiornoList[1].meteoMappa[6].seraCielo,
                vento: ref.previsioniPerGiornoList[1].meteoMappa[6].seraVento,
                cieloPos: {
                    posX: 227,
                    posY: 183
                },
                ventoPos: {
                    posX: 233,
                    posY: 226
                }

            },
            {

                cielo: ref.previsioniPerGiornoList[1].meteoMappa[7].seraCielo,
                vento: ref.previsioniPerGiornoList[1].meteoMappa[7].seraVento,
                cieloPos: {
                    posX: 201,
                    posY: 283
                },
                ventoPos: {
                    posX: 233,
                    posY: 270
                }

            }

        ];

        ref.setupInitCanvas(ref.canvasElemDomaniSera);

        for (var i = 0; i < this.arrayForMapImgDomaniSera.length; i++) {

            (function (i) {
                ref.addImageToCanvas(ref.arrayForMapImgDomaniSera[i].cielo, ref.arrayForMapImgDomaniSera[i].cieloPos.posX, ref.arrayForMapImgDomaniSera[i].cieloPos.posY, ref.canvasElemDomaniSera);
                ref.addImageToCanvas(ref.arrayForMapImgDomaniSera[i].vento, ref.arrayForMapImgDomaniSera[i].ventoPos.posX, ref.arrayForMapImgDomaniSera[i].ventoPos.posY, ref.canvasElemDomaniSera);
            })(i)

        }

        ref.addImageToCanvas(ref.previsioniPerGiornoList[1].meteoMappa[8].seraMare, 45, 180, ref.canvasElemDomaniSera);
        ref.addImageToCanvas(ref.previsioniPerGiornoList[1].meteoMappa[9].seraMare, 110, 225, ref.canvasElemDomaniSera);

    }


    createArrayForMapImgDopodomaniMattina() {

        var ref = this;

        this.arrayForMapImgDopodomaniMattina = [

            {

                cielo: ref.previsioniPerGiornoList[2].meteoMappa[0].mattinaCielo,
                vento: ref.previsioniPerGiornoList[2].meteoMappa[0].mattinaVento,
                cieloPos: {
                    posX: 18,
                    posY: 97
                },
                ventoPos: {
                    posX: 53,
                    posY: 138
                }

            },
            {

                cielo: ref.previsioniPerGiornoList[2].meteoMappa[1].mattinaCielo,
                vento: ref.previsioniPerGiornoList[2].meteoMappa[1].mattinaVento,
                cieloPos: {
                    posX: 40,
                    posY: 43
                },
                ventoPos: {
                    posX: 77,
                    posY: 87
                }

            },
            {

                cielo: ref.previsioniPerGiornoList[2].meteoMappa[2].mattinaCielo,
                vento: ref.previsioniPerGiornoList[2].meteoMappa[2].mattinaVento,
                cieloPos: {
                    posX: 105,
                    posY: 135
                },
                ventoPos: {
                    posX: 113,
                    posY: 175
                }

            },
            {

                cielo: ref.previsioniPerGiornoList[2].meteoMappa[3].mattinaCielo,
                vento: ref.previsioniPerGiornoList[2].meteoMappa[3].mattinaVento,
                cieloPos: {
                    posX: 134,
                    posY: 75
                },
                ventoPos: {
                    posX: 173,
                    posY: 120
                }

            },
            {

                cielo: ref.previsioniPerGiornoList[2].meteoMappa[4].mattinaCielo,
                vento: ref.previsioniPerGiornoList[2].meteoMappa[4].mattinaVento,
                cieloPos: {
                    posX: 160,
                    posY: 180
                },
                ventoPos: {
                    posX: 188,
                    posY: 163
                }

            },
            {

                cielo: ref.previsioniPerGiornoList[2].meteoMappa[5].mattinaCielo,
                vento: ref.previsioniPerGiornoList[2].meteoMappa[5].mattinaVento,
                cieloPos: {
                    posX: 164,
                    posY: 219
                },
                ventoPos: {
                    posX: 193,
                    posY: 244
                }

            },
            {

                cielo: ref.previsioniPerGiornoList[2].meteoMappa[6].mattinaCielo,
                vento: ref.previsioniPerGiornoList[2].meteoMappa[6].mattinaVento,
                cieloPos: {
                    posX: 227,
                    posY: 183
                },
                ventoPos: {
                    posX: 233,
                    posY: 226
                }

            },
            {

                cielo: ref.previsioniPerGiornoList[2].meteoMappa[7].mattinaCielo,
                vento: ref.previsioniPerGiornoList[2].meteoMappa[7].mattinaVento,
                cieloPos: {
                    posX: 201,
                    posY: 283
                },
                ventoPos: {
                    posX: 233,
                    posY: 270
                }

            }

        ];

        ref.setupInitCanvas(ref.canvasElemDopodomani);

        for (var i = 0; i < this.arrayForMapImgDopodomaniMattina.length; i++) {

            (function (i) {
                ref.addImageToCanvas(ref.arrayForMapImgDopodomaniMattina[i].cielo, ref.arrayForMapImgDopodomaniMattina[i].cieloPos.posX, ref.arrayForMapImgDopodomaniMattina[i].cieloPos.posY, ref.canvasElemDopodomani);
                ref.addImageToCanvas(ref.arrayForMapImgDopodomaniMattina[i].vento, ref.arrayForMapImgDopodomaniMattina[i].ventoPos.posX, ref.arrayForMapImgDopodomaniMattina[i].ventoPos.posY, ref.canvasElemDopodomani);
            })(i)

        }

        ref.addImageToCanvas(ref.previsioniPerGiornoList[2].meteoMappa[8].mattinaMare, 45, 180, ref.canvasElemDopodomani);
        ref.addImageToCanvas(ref.previsioniPerGiornoList[2].meteoMappa[9].mattinaMare, 110, 225, ref.canvasElemDopodomani);

    }

    createArrayForMapImgDopodomaniPome() {

        var ref = this;

        this.arrayForMapImgDopodomaniPome = [

            {

                cielo: ref.previsioniPerGiornoList[2].meteoMappa[0].pomeriggioCielo,
                vento: ref.previsioniPerGiornoList[2].meteoMappa[0].pomeriggioVento,
                cieloPos: {
                    posX: 18,
                    posY: 97
                },
                ventoPos: {
                    posX: 53,
                    posY: 138
                }

            },
            {

                cielo: ref.previsioniPerGiornoList[2].meteoMappa[1].pomeriggioCielo,
                vento: ref.previsioniPerGiornoList[2].meteoMappa[1].pomeriggioVento,
                cieloPos: {
                    posX: 40,
                    posY: 43
                },
                ventoPos: {
                    posX: 77,
                    posY: 87
                }

            },
            {

                cielo: ref.previsioniPerGiornoList[2].meteoMappa[2].pomeriggioCielo,
                vento: ref.previsioniPerGiornoList[2].meteoMappa[2].pomeriggioVento,
                cieloPos: {
                    posX: 105,
                    posY: 135
                },
                ventoPos: {
                    posX: 113,
                    posY: 175
                }

            },
            {

                cielo: ref.previsioniPerGiornoList[2].meteoMappa[3].pomeriggioCielo,
                vento: ref.previsioniPerGiornoList[2].meteoMappa[3].pomeriggioVento,
                cieloPos: {
                    posX: 134,
                    posY: 75
                },
                ventoPos: {
                    posX: 173,
                    posY: 120
                }

            },
            {

                cielo: ref.previsioniPerGiornoList[2].meteoMappa[4].pomeriggioCielo,
                vento: ref.previsioniPerGiornoList[2].meteoMappa[4].pomeriggioVento,
                cieloPos: {
                    posX: 160,
                    posY: 180
                },
                ventoPos: {
                    posX: 188,
                    posY: 163
                }

            },
            {

                cielo: ref.previsioniPerGiornoList[2].meteoMappa[5].pomeriggioCielo,
                vento: ref.previsioniPerGiornoList[2].meteoMappa[5].pomeriggioVento,
                cieloPos: {
                    posX: 164,
                    posY: 219
                },
                ventoPos: {
                    posX: 193,
                    posY: 244
                }

            },
            {

                cielo: ref.previsioniPerGiornoList[2].meteoMappa[6].pomeriggioCielo,
                vento: ref.previsioniPerGiornoList[2].meteoMappa[6].pomeriggioVento,
                cieloPos: {
                    posX: 227,
                    posY: 183
                },
                ventoPos: {
                    posX: 233,
                    posY: 226
                }

            },
            {

                cielo: ref.previsioniPerGiornoList[2].meteoMappa[7].pomeriggioCielo,
                vento: ref.previsioniPerGiornoList[2].meteoMappa[7].pomeriggioVento,
                cieloPos: {
                    posX: 201,
                    posY: 283
                },
                ventoPos: {
                    posX: 233,
                    posY: 270
                }

            }

        ];

        ref.setupInitCanvas(ref.canvasElemDopodomaniPome);

        for (var i = 0; i < this.arrayForMapImgDopodomaniPome.length; i++) {

            (function (i) {
                ref.addImageToCanvas(ref.arrayForMapImgDopodomaniPome[i].cielo, ref.arrayForMapImgDopodomaniPome[i].cieloPos.posX, ref.arrayForMapImgDopodomaniPome[i].cieloPos.posY, ref.canvasElemDopodomaniPome);
                ref.addImageToCanvas(ref.arrayForMapImgDopodomaniPome[i].vento, ref.arrayForMapImgDopodomaniPome[i].ventoPos.posX, ref.arrayForMapImgDopodomaniPome[i].ventoPos.posY, ref.canvasElemDopodomaniPome);
            })(i)

        }

        ref.addImageToCanvas(ref.previsioniPerGiornoList[2].meteoMappa[8].pomeriggioMare, 45, 180, ref.canvasElemDopodomaniPome);
        ref.addImageToCanvas(ref.previsioniPerGiornoList[2].meteoMappa[9].pomeriggioMare, 110, 225, ref.canvasElemDopodomaniPome);

    }

    createArrayForMapImgDopodomaniSera() {

        var ref = this;

        this.arrayForMapImgDopodomaniSera = [

            {

                cielo: ref.previsioniPerGiornoList[2].meteoMappa[0].seraCielo,
                vento: ref.previsioniPerGiornoList[2].meteoMappa[0].seraVento,
                cieloPos: {
                    posX: 18,
                    posY: 97
                },
                ventoPos: {
                    posX: 53,
                    posY: 138
                }

            },
            {

                cielo: ref.previsioniPerGiornoList[2].meteoMappa[1].seraCielo,
                vento: ref.previsioniPerGiornoList[2].meteoMappa[1].seraVento,
                cieloPos: {
                    posX: 40,
                    posY: 43
                },
                ventoPos: {
                    posX: 77,
                    posY: 87
                }

            },
            {

                cielo: ref.previsioniPerGiornoList[2].meteoMappa[2].seraCielo,
                vento: ref.previsioniPerGiornoList[2].meteoMappa[2].seraVento,
                cieloPos: {
                    posX: 105,
                    posY: 135
                },
                ventoPos: {
                    posX: 113,
                    posY: 175
                }

            },
            {

                cielo: ref.previsioniPerGiornoList[2].meteoMappa[3].seraCielo,
                vento: ref.previsioniPerGiornoList[2].meteoMappa[3].seraVento,
                cieloPos: {
                    posX: 134,
                    posY: 75
                },
                ventoPos: {
                    posX: 173,
                    posY: 120
                }

            },
            {

                cielo: ref.previsioniPerGiornoList[2].meteoMappa[4].seraCielo,
                vento: ref.previsioniPerGiornoList[2].meteoMappa[4].seraVento,
                cieloPos: {
                    posX: 160,
                    posY: 180
                },
                ventoPos: {
                    posX: 188,
                    posY: 163
                }

            },
            {

                cielo: ref.previsioniPerGiornoList[2].meteoMappa[5].seraCielo,
                vento: ref.previsioniPerGiornoList[2].meteoMappa[5].seraVento,
                cieloPos: {
                    posX: 164,
                    posY: 219
                },
                ventoPos: {
                    posX: 193,
                    posY: 244
                }

            },
            {

                cielo: ref.previsioniPerGiornoList[2].meteoMappa[6].seraCielo,
                vento: ref.previsioniPerGiornoList[2].meteoMappa[6].seraVento,
                cieloPos: {
                    posX: 227,
                    posY: 183
                },
                ventoPos: {
                    posX: 233,
                    posY: 226
                }

            },
            {

                cielo: ref.previsioniPerGiornoList[2].meteoMappa[7].seraCielo,
                vento: ref.previsioniPerGiornoList[2].meteoMappa[7].seraVento,
                cieloPos: {
                    posX: 201,
                    posY: 283
                },
                ventoPos: {
                    posX: 233,
                    posY: 270
                }

            }

        ];

        ref.setupInitCanvas(ref.canvasElemDopodomaniSera);

        for (var i = 0; i < this.arrayForMapImgDopodomaniSera.length; i++) {

            (function (i) {
                ref.addImageToCanvas(ref.arrayForMapImgDopodomaniSera[i].cielo, ref.arrayForMapImgDopodomaniSera[i].cieloPos.posX, ref.arrayForMapImgDopodomaniSera[i].cieloPos.posY, ref.canvasElemDopodomaniSera);
                ref.addImageToCanvas(ref.arrayForMapImgDopodomaniSera[i].vento, ref.arrayForMapImgDopodomaniSera[i].ventoPos.posX, ref.arrayForMapImgDopodomaniSera[i].ventoPos.posY, ref.canvasElemDopodomaniSera);
            })(i)

        }

        ref.addImageToCanvas(ref.previsioniPerGiornoList[2].meteoMappa[8].seraMare, 45, 180, ref.canvasElemDopodomaniSera);
        ref.addImageToCanvas(ref.previsioniPerGiornoList[2].meteoMappa[9].seraMare, 110, 225, ref.canvasElemDopodomaniSera);

    }

    getIndByZona(zona){
        let zonaFiltered = this.indZone.filter(el => el.zona == zona)
        return zonaFiltered[0].ind
    }
}
